import React, { SVGProps } from 'react';
import { useTheme } from 'react-admin';
import logo from "./wam-client-logo.svg";

interface LogoProps extends SVGProps<SVGSVGElement> {
  inverted?: boolean;
}

const Logo = ({ inverted = false, ...props }: LogoProps) => {
    const [ theme ] = useTheme()
    if (theme === 'dark') {
        inverted = true;
    }
    return (
    <div>
      <img 
        src={logo} 
        alt="logo" 
        style={{ 
          height: 29, 
          // width: 36, 
          filter: inverted ? 'invert(100%)' : 'none',
        }}
      /> 
    </div>
)};

export default Logo;